export default __webpack_public_path__ + "static/media/presentation.2d949a93.png";